import { UnorderedList } from '@fiverr-private/list';
import withImpression from '../helpers/withImpression';

export default withImpression(UnorderedList);
